module.exports = __webpack_public_path__ + "img/110.3843646.svg";